import { react, useState, useEffect, useRef } from 'react';


export default function ExistingPickup(props) {

    let panel = null;
    if (props.pickupRequest.Status_Reason === 'Unscheduled') {
        panel =  <div>
                
                <div>Your pickup request has been added to our Sipzee Marketplace where a returner will claim it and schedule a pickup date and time window.
                    Please place your bottles & cans in garbage bags or boxes.
                    Please have your returns available during the scheduled window for a contact-less pickup.
                    Our returners use their personal vehicles and cannot empty a trash bin of loose bottles & cans into their car.
                </div>

                <div style={{ marginTop: '20px', color: 'var(--sipzee-green)', fontSize: '22pt', fontWeight: 'bold' }}>What if nobody schedules my pickup?</div>
                <div>
                    In order to provide great service, we try to only open up new areas if enough returners are servicing it.
                    Our returners are not employees and get to select when they want to pickup. While it is unusual, your pickup request could remain unclaimed for several days.
                </div>
            </div >
    }
    else {
        panel = <div>
            Your request is scheduled for pickup on {props.pickupRequest.ScheduledPickUpDate} between {props.pickupRequest.EstPickUpWindow.replace("_", "-")} 
        </div>
    }

    return (
        <div>
            <div style={{ marginTop: '20px', color: 'var(--sipzee-green)', fontSize: '22pt', fontWeight: 'bold' }}>You already have an active request.</div>

            {panel }
          
        </div>
    )
}